// extracted by mini-css-extract-plugin
export var learning_object_list = "learningObjectList-module--learning_object_list--d743e";
export var learning_object_list_wrapper = "learningObjectList-module--learning_object_list_wrapper--d6774";
export var list_item = "learningObjectList-module--list_item--99303";
export var more_link = "learningObjectList-module--more_link--099ed";
export var more_link_wrapper = "learningObjectList-module--more_link_wrapper--15e25";
export var pagination = "learningObjectList-module--pagination--c4723";